import {ENV} from 'features/ui/enums';
import {getCurrentEnv, getCurrentSiteId, getEnvSpecificTestUrl, getEnvSpecificUrl} from 'features/services/utils/env-helper';

import {EpiImage} from "features/search/types";

// In Storybook there is no CDN/env, so getCDNBaseURL() returns '' and the URL builders below would
// produce a broken relative path. Mirror AsyncImage's isStorybook behaviour and return a seeded
// Picsum photo instead, so components that build a raw <img src> / background-image from these
// helpers (FloorplanTabber etc.) render with a realistic image. The guard is inert in the app
// build (STORYBOOK is only 'true' under Storybook's Vite).
const isStorybook = (import.meta as unknown as { env: Record<string, string> }).env.STORYBOOK === 'true';

// Seeded so the same source stays stable across reloads; absolute http(s) URLs pass through as-is.
// Unlike AsyncImage there is no onError SVG fallback here — these helpers return a plain string used
// directly in an <img src> / CSS background-image, so a failed load can't be intercepted at this layer.
const storybookImage = (width: number, height: number, rawUrl: string) => {
    if (/^https?:\/\//i.test(rawUrl)) return rawUrl;
    const seed = encodeURIComponent((rawUrl.split('/').pop() || 'jm').replace(/\.[^.]+$/, '') || 'jm');
    return `https://picsum.photos/seed/${seed}/${width}/${height}`;
};

export const getCDNBaseURL = () => {
    switch (getCurrentEnv()) {
        case ENV.LOCAL:
        case ENV.DEV:
            return `${getEnvSpecificTestUrl(getCurrentSiteId(), true)}/cdn-cgi/image/`;
        case ENV.PREPROD:
        case ENV.PROD:
        case ENV.TEST:
            return `${getEnvSpecificUrl(getCurrentSiteId(), true)}/cdn-cgi/image/`;
        case "":
            return '';

    }
};

const isStandingImage = (image: EpiImage) => {
    if(image && image.orgHeight && image.orgWidth) {

        if(image.orgHeight > image.orgWidth) {
            return true;
        }

        return false;
    }

    return false;
};

export const getImageUrlFromCDN = (image: EpiImage, internalQuality: number, noCrop: boolean) => {

    if (isStorybook) {
        const standing = isStandingImage(image);
        const width = standing ? Math.round(internalQuality / 3 * 2) : internalQuality;
        const height = standing ? internalQuality : Math.round(internalQuality / 3 * 2);
        return storybookImage(width, height, image.url);
    }

    let url = getCDNBaseURL();

    const baseUrl =  (image.url.indexOf('http://') === 0 || image.url.indexOf('https://') === 0) ? '' : getEnvSpecificUrl(getCurrentSiteId(), true);

    if(isStandingImage(image)) {
        url += `width=${Math.round(internalQuality/3*2)},height=${internalQuality},quality=75`;
    } else {
        url += `width=${internalQuality},height=${Math.round(internalQuality/3*2)},quality=75`;
    }

    if(!noCrop) {
        url += ',fit=crop';
    }

    url += `,format=webp/${baseUrl}${image.url}`;


    return url;
};

export const getBackgroundImageUrlFromCDN = (imageUrl: string, internalQuality: number, noCrop: boolean) => {

    if (isStorybook) {
        return storybookImage(internalQuality, Math.round(internalQuality / 3 * 2), imageUrl);
    }

    let url = getCDNBaseURL();

    const baseUrl =  (imageUrl.indexOf('http://') === 0 || imageUrl.indexOf('https://') === 0) ? '' : getEnvSpecificUrl(getCurrentSiteId(), true);

    url += `width=${internalQuality},height=${Math.round(internalQuality/3*2)},quality=75`;
  
    if(!noCrop) {
        url += ',fit=crop';
    }

    url += `,format=webp/${baseUrl}${imageUrl}`;

    return url;
};
